<template>
    <div class="  con_content">
        
        <div class="container">
            <div class="container_top h_48">
                背景图管理
               
            </div>     
            <div >
                
                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10">所属类目 : &nbsp;</div> 
                                <div class="lft pointer" :class="[title_num == -1 ?'colorP':'']"  @click="title_num = -1;guid = 'better'"  > 推荐 </div>
                                <div class="lft pointer" v-for="(item,num) in titles" :class="[title_num == num?'colorP':'']"  @click="title_num = num;guid = item.guid" :key="num"> &nbsp; <span class="cBlack">/</span> &nbsp;{{item.name}} </div>
                                
                                                
                            </div> 
                             
                            <Button class="rgt mR20 top14" @click="route='/layout/circle/background/add';out_btnFun(null,0)"  type="info">添加背景图</Button> 
                            <Button class="rgt mR20 top14" @click="lookFun"  type="info">查看类目</Button>   
                        </Row>        
                    </div>
                  
                </div>
                <div class="my_table">
                    
                    <div class="my_search" >
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10 fw900 fon fs18">背景图列表 </div> 
                                       
                            </div> 
                            <Col span="4" class="listIpt rgt mR20">
                                <Input  ref='isFocuseA'    :maxlength='20' @keyup.enter.native="nameFun" v-model="name"  class='ipt   top13 '  placeholder="请输入背景图名"  >
                                    <Button size="small" @click='nameFun'   slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                            
                        </Row>        
                    </div>

                </div>
                <div class="my_table lie">
                    
                    <div  v-for="(item,num) in data1" :key="num" :class="{'bg_box':true,'bg_box5':(num+1)%8 == 0}">
                        <img :src="item.url" alt="">
                        <div class="box">
                            <div class="box_c box_l">
                                <p><b class="fs14">{{item.name}}&nbsp;&nbsp;({{item.sort}})</b></p>
                                <p class="fs12" style="opacity:0.43">所属类目: {{item.backgroundTypeName}}</p>
                                <p class="fs10 top5" style="opacity:0.25">{{  item.createTime.split(" ")[0] }}</p>
                            </div>
                            <div class="box_c box_r">
                                <p class="fs14"><b>状态</b></p>
                                <p><i-switch class=""  size="small" v-model="item.display" :data-guid="item.guid" :data-bguid="item.backgroundTypeGuid" :true-value="Number(0)" :false-value="Number(1)"  @on-change="change_out_zt" /></p>
                                <p class="fs10 top5"><span class="br_edt pointer" @click='route="/layout/circle/background/editor";out_btnFun(item,1)'>编辑</span><span class="br_del pointer" @click='route="/layout/circle/background/del";out_btnFun(item,2)' >删除</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer>
                    <Page  :current.sync="page" :total="total" :page-size='size' :page-size-opts='[8,16,24,32]'   @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                </Footer>
            </div>         
        </div>

        <!-- 添加背景图,编辑背景图,删除背景图 -->
        <Modal
            v-model="out_btn"
            :title="out_title"
            
            class-name="vertical-center-modal"
            width="520"
        >
            <div slot="footer">
                <Button type='text' size='large' @click='out_btnFail'>取消</Button>
                <Button type='primary' size='large' @click='out_btnSucc'>{{out_succ}}</Button>
            </div>
            
            <p  v-if="out_btn_num == 2">确定删除背景图吗?</p>
            <ul class="layout_ul" v-if="out_btn_num != 2">
               
                <!-- 标题 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 标题 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model1"   type='text' class="ipt"  placeholder="请输入标题"    />
                    </div>                                            
                </li>
                <!-- 单选 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 分类描述 :</div> 
                    <div class="list_con padt2">
                        <RadioGroup v-model="out_model2">
                            <Radio v-for="(item,num) in data"  :label="item.guid" :key="num">
                                
                                <span>{{item.name}}</span>
                            </Radio>
                            
                        </RadioGroup>
                    </div>                                            
                </li>
                
                <!-- 孝心值 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 孝心值 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model6"   type='number' class="ipt"  placeholder="请输入孝心值"    />
                    </div>                                            
                </li>
                <!-- 排序 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 排序 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model3"   type='number' class="ipt"  placeholder="请输入排序"   />
                    </div>                                            
                </li>
                
                <!-- 上传附件 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 上传图片 :</div> 
                    <div class="list_con">
                        <cropper  @childFun="childFun2"      :data="cropper_data"  ></cropper>

                    </div>                                            
                </li>
                <!-- 是否推荐 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 推荐状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model4" :true-value="Number(1)" :false-value="Number(0)" @on-change="change_out_isBetter" />
                    </div>                                                
                </li>
                <!-- 是否隐藏 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 显示状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model5" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_out_display" />
                    </div>                                                
                </li>
            </ul>
        </Modal>           
        <!-- 查看类目  -->
        <Modal
            v-model="lm"
            title="背景图类目"
            class-name="vertical-center-modal"
            width="1000"
            >
            <div slot="footer">     
                <Button type='primary' size='large' @click='lookSucc'>关闭</Button>
            </div>
            <div class="my_table bottom20"  >
                    
                <div class="my_search" style="margin-bottom:1px;">
                    
                    <Row class="search_row">  
                        <div  class="search_name">           <!--  0 添加; 1 编辑; 2 删除  -->
                        <Button class="mR5"    type="info"    @click='route="/layout/circle/background/m_add";m_btnFun(null,0);' > <Icon type="md-add" />添加</Button>                              
                        </div>
                        
                    </Row>
                    
                </div>
                <Table     border :columns="columns" :data="data" ref='table' >
                    <template slot-scope="{ row, index }" slot="btn" >
                 
                        <span  >
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click='route="/layout/circle/background/m_editor";m_btnFun(row,1)'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/background/m_del";m_btnFun(row,2)'  type="error"      icon="md-close"></Button>
                            </Poptip>
                        </span>

                    </template>                        
                </Table>
            
            </div>
        </Modal> 

        <!-- 类目弹窗的按钮弹窗 -->
        <Modal
            v-model="m_btn"
            :title="m_title"
            
            class-name="vertical-center-modal"
            width="520"
        >
            <div slot="footer">
                <Button type='text' size='large' @click='m_btnFail'>取消</Button>
                <Button type='primary' size='large' @click='m_btnSucc'>{{m_succ}}</Button>
            </div>
            
            <p  v-if="m_btn_num == 2">确定删除类目吗?</p>
            <ul class="layout_ul" v-if="m_btn_num != 2">
               
                <!-- 分类名称 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类名称 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model1"   type='text' class="ipt"  placeholder="请输入分类名称"    />
                    </div>                                            
                </li>
                <!-- 分类描述 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类描述 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model2"   type='text' class="ipt"  placeholder="请输入分类描述"    />
                    </div>                                            
                </li>
                <!-- 分类排序 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类排序 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model3"   type='number' class="ipt"  placeholder="请输入分类排序"    />
                    </div>                                            
                </li>
                <!-- 分类状态 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="m_model4" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_btn" />
                    </div>                                                
                </li>
            </ul>
        </Modal> 


        <!-- <div class="bg_pic">
            <img src="https://file.jiapuji.vip/gateway/file/files/img/memorial/scene/bg/f56acc69c3134f2aac8f8830c936f5da.jpg" alt="">
        </div> -->
    </div>
    
</template>
<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    
    import cropper from '../../child_vue/vue_cropper.vue';
    import aplayer from 'vue-aplayer';
    export default {
        name:'recommend',
        data () {
            return {
                
                token: null,
                route: null,
                guid: 'better', 
                my_guid:null,
                titles: [],
                title_num: -1,
                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 16,
                //搜索
                search_page:1,
                search_size: 20,
                // 类目 
                columns:[],   
                data:[],
              
                // 主体编辑
                out_url: null,  //场景路径
                
                out_model1:null,  //场景名称
                out_model2:null,  //场景guid
                out_model3:0,  //场景排序
                out_model4:"0",  //是否推荐
                out_model5:"0",  //是否隐藏
                out_model6:0,     //收取孝心值
                

                // 类目编辑
                m_model1:null,  //分类名称
                m_model2:null,  //分类描述
                m_model3:null,  //分类排序
                m_model4:null,  //隐藏分类

                name: null,

                lo: false,
                out_btn: null,  
                out_guid: null,
                out_btn_num: null,
                out_title: null,
                out_succ: null,

                lm: false,     //是否弹出类目
                m_btn: false , //类目弹窗的按钮弹窗
                m_guid: null,
                m_btn_num: 0,
                m_title: "添加类目",
                m_succ: "添加",

                // 上传背景图
                up_data: null,
                file_name: null,
                file_path: null,

                

                // 上传图片
                             
                cropper_data:{
                    btn_name: '上传图片',  //按钮名
                    outputType: 'jpeg',   //生成图片格式
                    type:'8',
                    vCropper:'5',
                    enlarge:"10", 
                    autoCropWidth:"108",
                    autoCropHeight:"192"
                },  

                child_val: null,  //child 反馈
            }
        },
     
        watch:{
           title_num(val){
               let that = this;
               that.load1();
           }
          
        },
        filters:{
            // bgTime(time){
            //     let that = this;
                
            //     let bt = new Date(time);
            //     let btt;
            //     btt = bt.getFullYear() + '年' +  parseInt(bt.getMonth()+1) + '月' + bt.getDate() + '日';
                
            //     return btt;
            // }
        },
        components: {
          aplayer,cropper
        },
        computed: {
            
       
        },
        
        
        methods: {
            
            load(){
              let that = this;
              that.$myAjax.get('admin/service/admin/fame/background/type/image?type=0').then( res => {
                  that.titles = res.data.data;
                  
                  that.columns = [
                       {title:'排序',key:'sort',align:'center',width: 80},
                       {title:'名称',key:'name',align:'center',minWidth: 100,ellipsis: true},
                       {title:'分类描述',key:'content',align:'center',minWidth:150},
                       {title:'状态',key:'display',align:'center',width:'110',
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.display,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {
                                             
                                              that.$myAjax.put(
                
                                                  'admin/service/admin/fame/background/type?route=/layout/circle/background/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 0,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                  that.load()
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'添加时间',key:'createTime',align:'center',minWidth:130,maxWidth:190},
                      {title:'操作',slot:'btn',align:'center',width:160,fixed: 'right'}
                  ];
                  that.data = res.data.data;
                  
                  that.out_model2 = that.data[0].guid;
                  
              })
          },
          load1(){
            
              let that = this;
              let data = {
                  guid: that.guid,
                  page: that.page,
                  size: that.size,
                  type: 0

              };
              
              
              that.$myAjax.get('admin/service/admin/fame/background/all'+that.$ajaxNull.get(data)).then( res => {
                  
                  
                  that.data1 = res.data.data.list;
                  
                  that.page = res.data.data.pageNum;
                  that.size = res.data.data.pageSize;
                  that.total = res.data.data.total;

                  
              })
          },
          
          change_page(){
              this.load1();
          },
          change_size(size){
              this.size = size;
              this.load1();
          },
          


            // 添加背景图
            //背景图 中按钮 ,m_btn_num 0 添加，1 编辑 ， 2 删除
            out_btnFun(row,num){
                let that = this;
                
                that.out_btn = true;
                that.out_btn_num = num;
                
                if(that.out_btn_num == 0){
                    that.out_title = "添加背景图";
                    that.out_succ = "添加";
                }else if(that.out_btn_num == 1){
                    that.out_guid = row.guid;
                    that.out_title = "编辑背景图";
                    that.out_succ = "修改";
                    
                }else if(that.out_btn_num == 2){
                    that.out_guid = row.guid;
                    that.out_title = "提示";
                    that.out_succ = "删除";
                }
                if(num == 0){
                    that.out_model1 = null;
                    // that.out_model2 = null;
                    that.out_model3 = null;   //排序
                    that.out_model4 = 0;
                    that.out_model5 = 0;
                    that.out_model6 = null;    //收取孝心值
                    that.child_val = null;
                    
                }else if(num == 1){
                    that.out_model1 = row.name;
                    that.out_model2 = row.backgroundTypeGuid;
                    that.out_model3 = row.sort;
                    that.out_model4 = row.isBetter;
                    that.out_model5 = row.display;
                    that.out_model6 = row.money;
                    that.child_val = null;
                }
            },
            out_btnFail(){
                this.out_btn = false;
            },
            out_btnSucc(){
                let that = this;
                
                let sort = that.out_model3?JSON.parse(that.out_model3):null;
                let money = that.out_model6?JSON.parse(that.out_model6):null;
                let data = {
                    name: that.out_model1,
                    backgroundTypeGuid: that.out_model2,
                    sort: sort,
                    isBetter: that.out_model4,
                    display: that.out_model5,
                    money: money,
                    type: 0,
                    url: null
                    
                }
                
                let bn = that.out_btn_num; 
                if( bn != 2){
                    if(!that.child_val){  //child_val==false 的时候 不上传 图片
                        data.guid = null;
                        data.url = null; 
                        if(bn == 0){                     
                            that.$myAjax.post('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }else if(bn == 1){
                            data.guid = that.out_guid;
                            that.$myAjax.put('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }              
                    }else{
                        that.$upload(           //上传图片
                            that.child_val
                        ).then(res => { 
                            data.guid = null;
                            data.url = res.data.data.name; 
                            if(bn == 0){                     
                                that.$myAjax.post('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }else if(bn == 1){
                                data.guid = that.out_guid;
                                that.$myAjax.put('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }             
                            
                            
                        }).catch(res => {

                        });
                    }  
                }else if(bn == 2){
                    data.guid = that.out_guid;
                    that.$myAjax.delete('admin/service/admin/background?route=' + that.route+'&guid='+that.out_guid).then( res => {
                        if(res.data.code == 1){
                            that.out_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }
                

                
            },
            // 搜索名称
            nameFun(){
                let that = this;
                let data = {
                  name: that.name,
                  page: that.search_page,
                  size: that.search_size,
                  type: 0

                };
                if(that.name){
                    that.$myAjax.get('admin/service/admin/fame/background/search'+that.$ajaxNull.get(data)).then( res => {
                        that.data1 = res.data.data.list;
                        that.page = res.data.data.pageNum;
                        that.size = res.data.data.pageSize;
                        that.total = res.data.data.total;
                    })
                }else{
                    that.load1();
                }
                
                
            },
            // 页面 switch
           change_out_zt(bool){
               let that = this;
               
               
               that.$myAjax.put(              
                    'admin/service/admin/background?route=/layout/circle/background/editor',
                    {
                        "guid": event.target.dataset.guid,
                        // "backgroundTypeGuid": event.target.dataset.bguid,
                        "type": 0,
                        "display": bool
                    }               
                ).then( res => {
                    that.load1();
            
                }).catch( err => {
                    console.log(err)
                })
            },
            // 弹窗switch
           change_out_isBetter(bool){
               this.out_model4 = bool;
              
            },
           change_out_display(bool){
               this.out_model5 = bool;
              
            },
            //   类目
            change_btn(bool){
               this.m_model4 = bool;
              
            },
            //   查看类目
           lookFun(){
               this.lm = true;
           },
            lookSucc(){
               this.lm = false;
            },
            //类目 中按钮 ,m_btn_num 0 添加，1 编辑 ， 2 删除
            m_btnFun(row,num){
                let that = this;
                
                that.m_btn = true;
                that.m_btn_num = num;
                
                if(that.m_btn_num == 0){
                    that.m_title = "添加类目";
                    that.m_succ = "添加";
                }else if(that.m_btn_num == 1){
                    that.m_guid = row.guid;
                    that.m_title = "编辑类目";
                    that.m_succ = "修改";
                    
                }else if(that.m_btn_num == 2){
                    that.m_guid = row.guid;
                    that.m_title = "提示";
                    that.m_succ = "删除";
                }
                if(num == 0){
                    that.m_model1 = null;
                    that.m_model2 = null;
                    that.m_model3 = null;
                    that.m_model4 = 0;
                }else if(num == 1){
                    that.m_model1 = row.name;
                    that.m_model2 = row.content;
                    that.m_model3 = row.sort;
                    that.m_model4 = row.display;
                }
            },
            m_btnFail(){
                this.m_btn = false;
            },
            m_btnSucc(){
                let that = this;
                let data = {
                    name: that.m_model1,
                    content: that.m_model2,
                    sort: that.m_model3,
                    display: that.m_model4,
                    type: 0
                }
                if(that.m_btn_num == 0){
                    that.$myAjax.post('admin/service/admin/fame/background/type?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }else if(that.m_btn_num == 1){
                    
                    let data1 = data;
                    data1.guid = that.m_guid;
                    that.$myAjax.put('admin/service/admin/fame/background/type?route=' + that.route,that.$ajaxNull.post(data1)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }else if(that.m_btn_num == 2){
                    data.guid = that.m_guid;
                    that.$myAjax.delete('admin/service/admin/fame/background/type?route=' + that.route +'&guid='+ that.m_guid ).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }
            },
            

            

            // 上传图片反馈
            childFun2 (data){
                let that = this;
                that.child_val = data.pic_url;          
                
            },
            

          
            
         
        },
        mounted: function(){
           let that = this;
           that.my_guid = that.$store.state.guid;
           
           that.token = that.$store.state.token;
           

           that.load();
           that.load1();

        }
    }
</script>
<style scoped>
    .lie{
       height: auto;
       overflow: hidden;
    }

    /* 图片box  */
   .bg_box{
       float: left;
       width: calc(12.5% - 11.75px);
       height:auto;
       margin-right: 13px;
       margin-bottom: 13px;  
       background: #fafafa; 
       border-radius: 3px;
       overflow: hidden;   
   }
   .bg_box5{   /** 每排第5个 **/
       margin-right: 0!important;
   }
   .bg_box img{
       width: 100%;
   }
   
   .bg_box .box{
       width: 100%;
       height: auto;
       padding: 6px 10px;
       
       overflow: hidden;
   }
   .bg_box .box_c{
       
   }
   .bg_box .box_c p{
       height: 22px;
   }
   .bg_box .box_l{
       float: left;
       text-align: left;
   }
   .bg_box .box_r{
       float: right;
       text-align: right;
   }
   .bg_box .box_r .br_edt{
       
       padding-right: 5px;
       color: #2d8cf0;
   }
   .bg_box .box_r .br_del{
     
       color: #2d8cf0;
   }

   /* 大图片 */
   .bg_pic{
       position: fixed;
       width: 400px;
       height: auto;
       margin-left: 300px;
       /* z-index: 999999; */
   }
   .bg_pic img{
       width: 100%;
       height: 100%;
   }
</style>